// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Y4pMF93UEdFA8QX1976mG","heading":"_1gO66b7s63PxF04HeeYHt5","checkBox":"HCOU49jxYeIVDgB4eI5e-"};